import axios from 'axios/index'
import Vue from 'vue'

const namespaced = true

const state = {
  groupsUsers: [],
  servers: [],
  companyInfo: null,
  modalParamsCompany: null,
  modalParamsSubgroup: null,
  modalParamsUser: null,
  serverAlias: null,
  groupsUsersItem: null,
  groupDropdowns: null,
  subgroupDropdowns: null,
  userDropdowns: null,
  modalParamsGroupFCS: null,
  isBusy: null,
  busyModalTable: null,
  billingParamsStatic: null,
  billingDropdowns: null,
  infodecData: null,
  clientsProgrammData: null,
  dealers: null,
  dealersList: null,
  notificationStatuses: null
}
const actions = {
  getGroupsUsers ({ commit }) {
    commit('busyState', true)
    return axios.get('/api/private/v3.0/piportals/all/groups/')
      .then(response => {
        commit('setGroupsUsers', response.data)
        commit('busyState', false)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getGroupDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server + '/group/dropdowns/')
      .then(response => {
        commit('setGroupDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getGroupModalParams ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/groups/' + data.p_gid + '/')
      .then(response => {
        commit('setGroupModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createGroup ({ state, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server + '/groups/', data)
        .then(response => {
          commit('addCreatedGroup', response.data)
          commit('setActiveElement', response.data)
          resolve()
          /* dispatch('getGroupsUsers').then(() => {
            commit('setActiveElement', response.data)
            resolve()
          }) */
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editGroup ({ state, commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/', data)
        .then(response => {
          commit('addEditedGroup', response.data)
          commit('setActiveElement', response.data)
          resolve()
          /* dispatch('getGroupsUsers').then(() => {
            commit('setActiveElement', response.data)
            resolve()
          }) */
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getUserDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/user/dropdowns/')
      .then(response => {
        commit('setUserDropdowns', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getUserModalParams ({ state, commit }, data) {
    console.log('getUserModalParams ', data)
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.alias + '/users/' + data.p_id + '/')
      .then(response => {
        commit('setUserParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createUser ({ state, commit, dispatch }, data) {
    return axios({
      method: 'POST',
      url: '/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/users/',
      data: data
    })
      .then(response => {
        response.data.objtype = 'user'
        response.data.parent_p_gid = data.parent_p_gid
        commit('addCreatedUser', response.data)
        commit('setActiveElement', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editUser ({ state, commit, dispatch }, data) {
    return axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/users/' + state.groupsUsersItem.p_id + '/', data)
      .then(response => {
        response.data.objtype = 'user'
        response.data.parent_p_gid = data.parent_p_gid
        commit('addEditedUser', response.data)
        commit('setActiveElement', response.data)
        /* dispatch('getGroupsUsers').then(() => {
          commit('setActiveElement', response.data)
        }) */
      })
      .catch(error => {
        console.log(error)
      })
  },
  getSubgroupDropdowns ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.server_alias + '/subgroup/dropdowns/')
      .then(response => {
        commit('setSubgroupDropdowns', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getSubgroupModalParams ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + data.alias + '/subgroups/' + data.p_gid + '/')
      .then(response => {
        commit('setSubgroupModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createSubgroup ({ state, commit, dispatch }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/subgroups/', data)
      .then(response => {
        dispatch('getGroupsUsers').then(() => {
          commit('setActiveElement', response.data)
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  editSubgroup ({ state, commit, dispatch }, data) {
    return axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/', data)
      .then(response => {
        dispatch('getGroupsUsers').then(() => {
          commit('setActiveElement', response.data)
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  getGroupFCSData ({ state, commit, dispatch }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/fcs-profile/')
      .then(response => {
        commit('setGroupFCSModalParams', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editFCSData ({ state, commit, dispatch }, data) {
    console.log('data in editFCSData ', data)
    return axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/fcs-profile/', data)
      .then(response => {
        data.fb_id = response.data.client_id
        commit('addFcsProfile', data)
        commit('setActiveElement', data)
        // dispatch('getGroupsUsers')
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getSubgroupFCSData ({ state, commit, dispatch }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/fcs-profile/')
      .then(response => {
        commit('setGroupFCSModalParams', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  editSubgroupFCSData ({ state, commit, dispatch }, data) {
    return axios.patch('/api/private/v3.0/piportals/' + state.groupsUsersItem.alias + '/subgroups/' + state.groupsUsersItem.p_gid + '/fcs-profile/', data)
      .then(response => {
        dispatch('getGroupsUsers')
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getBillingProfile ({ state, commit }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/')
      .then(response => {
        commit('setBillingStatic', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getBillingDropdowns ({ state, commit, dispatch }, data) {
    commit('dataFromGroupsUsersItem', data)
    return axios.get('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/controls/')
      .then(response => {
        commit('setBillingDropdowns', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createCustomSubscribe ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/custom-subscribe/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createServiceUnlim ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/service-unlim/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createFullUnlim ({ state }, data) {
    return axios.post('/api/private/v3.0/piportals/' + state.groupsUsersItem.server_alias + '/groups/' + state.groupsUsersItem.p_gid + '/billing-profile/full-unlim/', data)
      .then(response => {
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  sendToArchive ({ dispatch }, data) {
    return axios.post('/api/private/v3.0/piportals/' + data.server_alias + '/groups/' + data.p_gid + '/archive-status-invert/')
      .then(() => {
        dispatch('getGroupsUsers')
      })
  },
  getDataFromCTM ({ rootState, commit }, data) {
    commit('busyStateModal', true)
    return axios.get('/api/private/v3.0/dealers/' + rootState.authorization.userInfo.company.company_profile.ctm_id + '/inns/' + data.inn + '/kpps/' + data.kpp + '/ctm-clients/')
      .then(response => {
        commit('busyStateModal', false)
        commit('setDataFromCTM', response.data)
        console.log(response)
      })
      .catch(error => {
        commit('busyStateModal', false)
        console.log(error)
      })
  },
  getDataFromInfodec ({ rootState, commit }, data) {
    commit('busyStateModal', true)
    return axios.get('/api/private/v3.0/dealers/' + rootState.authorization.userInfo.company.company_profile.ctm_id + '/inns/' + data.inn + '/kpps/' + data.kpp + '/fcs-operators/infodec/')
      .then(response => {
        commit('busyStateModal', false)
        commit('setDataFromInfodec', response.data)
        console.log(response)
      })
      .catch(error => {
        commit('busyStateModal', false)
        console.log(error)
      })
  },
  getAllDealersGroups ({ commit }) {
    commit('busyState', true)
    return axios.get('/api/private/v3.0/piportals/all/groups/all/')
      .then(response => {
        if (response.data.length > 1) {
          response.data.map((item, index) => {
            if (index > 0) {
              response.data[0].groups_data = response.data[0].groups_data.concat(item.groups_data)
            }
          })
        }
        commit('setGroupsUsers', response.data[0])
        commit('busyState', false)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getAllDealers ({ commit }) {
    return axios.get('/api/private/v3.0/piportals/all/groups/all-dealers/')
      .then(response => {
        commit('setDealersList', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getNotificationStatuses ({ commit }) {
    return axios.get('/api/private/v3.0/notification-statuses/')
      .then(response => {
        commit('setNotificationStatuses', response.data)
        console.log(response)
      })
      .catch(error => {
        console.log(error)
      })
  },
  downloadExcelFile (_, data) {
    return new Promise((resolve, reject) => {
      axios.get('/api/private/v3.0/piportals/all/groups/all/xlsx-report/?server_alias=' + data, { responseType: 'blob' })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  addFcsProfile (state, data) {
    const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
    state.groupsUsers[foundIndex].participant_id = (data.p_participant_id !== null ? data.p_participant_id : 'CTM')
  },
  addEditedUser (state, data) {
    if (data.parent_p_gid !== null) {
      const foundGroupIndex = state.groupsUsers.findIndex(x => x.p_gid === data.parent_p_gid)
      const foundSubgroupIndex = state.groupsUsers[foundGroupIndex].subgroups_json.findIndex(y => y.p_gid === data.p_gid)
      const foundUserIndex = state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users.findIndex(y => y.p_id === data.p_id)
      state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users[foundUserIndex] = data
    } else {
      const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
      const foundUserIndex = state.groupsUsers[foundIndex].users_json.findIndex(y => y.p_id === data.p_id)
      state.groupsUsers[foundIndex].users_json[foundUserIndex] = data
    }
  },
  addCreatedUser (state, data) {
    if (data.parent_p_gid !== null) {
      const foundGroupIndex = state.groupsUsers.findIndex(x => x.p_gid === data.parent_p_gid)
      const foundSubgroupIndex = state.groupsUsers[foundGroupIndex].subgroups_json.findIndex(y => y.p_gid === data.p_gid)
      state.groupsUsers[foundGroupIndex].subgroups_json[foundSubgroupIndex].users.push(data)
    } else {
      const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
      state.groupsUsers[foundIndex].users_json.push(data)
    }
  },
  addCreatedGroup (state, data) {
    state.groupsUsers.unshift(data)
  },
  addEditedGroup (state, data) {
    const foundIndex = state.groupsUsers.findIndex(x => x.p_gid === data.p_gid)
    state.groupsUsers[foundIndex] = Object.assign(state.groupsUsers[foundIndex], data)
  },
  setGroupsUsers (state, data) {
    data.groups_data.forEach(function (elm) {
      elm._showDetails = false
    })
    state.groupsUsers = data.groups_data.sort((a, b) => {
      const parseA = a.create_date.split('.');
      [parseA[0], parseA[1]] = [parseA[1], parseA[0]]
      const parseB = b.create_date.split('.');
      [parseB[0], parseB[1]] = [parseB[1], parseB[0]]
      return new Date(Date.parse(parseB.join('.'))) - new Date(Date.parse(parseA.join('.')))
    })
    data.servers_data.forEach((server) => {
      server.disabled = !server.is_success
    })
    state.servers = data.servers_data
    state.isBusy = false
  },
  setActiveElement (state, data) {
    const setElement = state.groupsUsers.filter(function (item) {
      if (data.fb_id === data.p_gid) {
        if (item.p_gid === data.p_gid) {
          Vue.set(item, '_rowVariant', 'success')
          setTimeout(function () {
            Vue.set(item, '_rowVariant', '')
            state.groupsUsers = state.groupsUsers.filter(function (elm) {
              return elm
            })
          }, 3000)
        }
      } else {
        if ((item.p_gid === data.p_gid) || (item.p_gid === data.parent_p_gid)) {
          item._showDetails = true
          if (data.objtype === 'group') {
            item.subgroups_json.forEach(subgroup => {
              if (subgroup.p_gid === data.p_gid) {
                subgroup.class = 'active'
                setTimeout(function () {
                  subgroup.class = 'nonactive'
                  state.groupsUsers = state.groupsUsers.filter(function (elm) {
                    return elm
                  })
                }, 3000)
              }
            })
          } else if (data.objtype === 'user') {
            const user = []
            let userFull = []
            item.subgroups_json.forEach(function (subgroup) {
              subgroup.users.forEach(function (elm) {
                user.push(elm)
              })
            })
            userFull = user.concat(item.users_json)
            userFull.forEach(function (user) {
              if (user.p_id === data.p_id) {
                user.class = 'active'
                setTimeout(function () {
                  user.class = 'nonactive'
                  state.groupsUsers = state.groupsUsers.filter(function (elm) {
                    return elm
                  })
                }, 3000)
              }
            })
          }
        }
      }
      return item
    })
    state.groupsUsers = setElement
  },
  setGroupModalParams (state, data) {
    state.modalParamsCompany = data
  },
  setGroupDropdowns (state, data) {
    state.groupDropdowns = data
  },
  setSubgroupModalParams (state, data) {
    state.modalParamsSubgroup = data
  },
  setSubgroupDropdowns (state, data) {
    state.subgroupDropdowns = data
  },
  setUserDropdowns (state, data) {
    state.userDropdowns = data
  },
  setUserParams (state, data) {
    state.modalParamsUser = data
  },
  setGroupFCSModalParams (state, data) {
    state.modalParamsGroupFCS = data
  },
  dataFromGroupsUsersItem (state, data) {
    state.groupsUsersItem = data
  },
  setBillingStatic (state, data) {
    state.billingParamsStatic = data
  },
  setBillingDropdowns (state, data) {
    state.billingDropdowns = data
  },
  busyState (state, data) {
    state.isBusy = data
  },
  busyStateModal (state, data) {
    state.busyModalTable = data
  },
  setDataFromCTM (state, data) {
    state.clientsProgrammData = data
  },
  setDataFromInfodec (state, data) {
    state.infodecData = data
  },
  setAllDealers (state, data) {
    data[0].groups_data.forEach(function (elm) {
      elm._showDetails = false
    })
    state.dealers = data[0].groups_data.sort((a, b) => {
      const parseA = a.create_date.split('.');
      [parseA[0], parseA[1]] = [parseA[1], parseA[0]]
      const parseB = b.create_date.split('.');
      [parseB[0], parseB[1]] = [parseB[1], parseB[0]]
      return new Date(Date.parse(parseB.join('.'))) - new Date(Date.parse(parseA.join('.')))
    })
    console.log(state.dealers)
    data[0].servers_data.forEach((server) => {
      server.disabled = !server.is_success
    })
    state.servers = data[0].servers_data
    state.isBusy = false
  },
  setDealersList (state, data) {
    data.unshift({
      fullname: 'Все дилеры',
      gid: null
    })
    state.dealersList = data
  },
  setNotificationStatuses (state, data) {
    data.map((item) => {
      item.label = item.name
      return item
    })
    state.notificationStatuses = data
  }
}
const getters = {}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
